/* This file uses control charachters in regex, which is an ESLint error.
   Since we did not write this code and i'm too scared to change it, i will disable the rule for this file. */
/* eslint-disable no-control-regex */

/**
 * Code is copied from https://github.com/braintree/sanitize-url
 * I simply could not install it via npm so I copy-pasted it.
 * The original had MIT license:
 *

MIT License

Copyright (c) 2017 Braintree

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
 */

const invalidProtocolRegex = /^(\W*)(javascript|data|vbscript)/im;
const htmlEntitiesRegex = /&#(\w+)(^\w|;)?/g;
const htmlCtrlEntityRegex = /&(newline|tab);/gi;
const ctrlCharactersRegex = /[\u0000-\u001F\u007F-\u009F\u2000-\u200D\uFEFF]/gim;
const urlSchemeRegex = /^.+(:|&colon;)/gim;

// adapted from https://stackoverflow.com/a/29824550/2601552
function decodeHtmlCharacters(str: string) {
  const removedNullByte = str.replace(ctrlCharactersRegex, "");
  return removedNullByte.replace(htmlEntitiesRegex, (_match, dec) => {
    return String.fromCharCode(dec);
  });
}

// The type of encoding is specific to the context of the page where the user-   controlled data is inserted.
export function sanitizeUrl(url?: string): string | null {
  try {
    if (!url) {
      return null;
    }

    let sanitizedUrl = decodeHtmlCharacters(url)
      .replace(htmlCtrlEntityRegex, "")
      .replace(ctrlCharactersRegex, "")
      .trim();

    if (!sanitizedUrl) {
      return null;
    }

    const urlSchemeParseResults = sanitizedUrl.match(urlSchemeRegex);

    if (urlSchemeParseResults && invalidProtocolRegex.test(urlSchemeParseResults[0])) {
      return null;
    }

    // Prepend a valid protocol if missing
    if (!sanitizedUrl.startsWith("http://") && !sanitizedUrl.startsWith("https://")) {
      sanitizedUrl = "https://" + sanitizedUrl;
    }

    // Validate URL format using a more lenient regex
    const urlRegex = new RegExp(/^[a-zA-Z0-9.-]+\:[^\s]+\//); // Allow any domain and protocol
    if (!urlRegex.test(sanitizedUrl.toString())) {
      return null; // Invalid URL format
    }

    return sanitizedUrl;
  } catch {
    console.error("Invalid URL format:", url);
    return null; // Invalid URL format or parsing error
  }
}
